import React from 'react';

import { IBasicStyledProps, IconSolidInfo, TooltipModel } from '@notino/react-styleguide-v20';

import { ReactFCV } from '@types';
import { stopPropagationMouseEvent } from '@utils/general';

import { DEFAULT_INFO_MARK_WIDTH, DEFAULT_TOOLTIP_TEXT_ALIGN, DEFAULT_TOOLTIP_WIDTH_MOBILE } from './constants';
import { StyledInfoMarkWrapper, StyledTooltip, StyledToolTipContent } from './styled';

interface IInfoMarkProps extends IBasicStyledProps {
  content: string | JSX.Element;
  iconWidth?: number;
  tooltipWidth?: number;
  tooltipTextAlign?: 'left' | 'center';
  interactive?: boolean;
  position?: TooltipModel.Position;
}

export const InfoMark: ReactFCV<IInfoMarkProps> = ({
  content,
  iconWidth = DEFAULT_INFO_MARK_WIDTH,
  tooltipWidth = DEFAULT_TOOLTIP_WIDTH_MOBILE,
  tooltipTextAlign = DEFAULT_TOOLTIP_TEXT_ALIGN,
  interactive = false,
  position = TooltipModel.Position.topCenter,
  ...rest
}) => (
  <StyledInfoMarkWrapper onClick={stopPropagationMouseEvent} {...rest}>
    <StyledTooltip
      data-testid="tooltip"
      position={position}
      interactive={interactive}
      content={
        <StyledToolTipContent data-testid="tooltip-content" width={tooltipWidth} textAlign={tooltipTextAlign}>
          {content}
        </StyledToolTipContent>
      }>
      <IconSolidInfo
        data-testid="info-circle-icon"
        color={'icon.tertiary'}
        width={`${iconWidth}px`}
        height={`${iconWidth}px`}
      />
    </StyledTooltip>
  </StyledInfoMarkWrapper>
);
